<div class="grid-row info info--{{ theme }}">
  <div *ngIf="title || description" class="xs-12 icon-wrapper">
    <div class="flex-column info-body">
      <h5 class="typog-body-large-bold xs--block md--inline mr-3 mb-none">
        <i
          *ngIf="icon"
          class="fa-thin fa-{{ icon }} fa-xl"
          [class.success]="icon === 'circle-check'"
        >
        </i>

        {{ title | stripHTML }}
      </h5>
      <div *ngIf="description" [innerHTML]="description"></div>
    </div>

    <button class="cta-section" (click)="changeCTA.emit()">
      <span *ngIf="cta" class="link typog-body-large-bold">{{ cta }} </span>
      <dgx-components-icon *ngIf="cta === 'Change'" name="edit" size="sm">
      </dgx-components-icon>
    </button>
  </div>
  <section *ngIf="showReallyHelpSection" class="really-helps xs-12">
    <h6>
      <dgx-components-icon name="thumbs-up"> </dgx-components-icon>
      This really helps
    </h6>
    <p>
      If you pick the right fault, the engineer will have a better chance of
      fixing it first time.
    </p>
  </section>

  <section *ngIf="showPleaseCheckAnswers" class="check-answers xs-12">
    <h6>
      <dgx-components-icon name="thumbs-up"> </dgx-components-icon>
      Please check your answers
    </h6>
    <p>
      By choosing the right fault, you’re helping the engineer fix it as
      efficiently as possible.
    </p>
  </section>
  <ng-content></ng-content>
</div>
